import { Col, Divider, Typography } from "@commonlibs";
import { TitledContentBody, TitledContentHeder } from "./TitledContent.styles";
import { TitledContentProps } from "./TitledContent.types";
import clsx from "clsx";

const TitledContent = ({ title, body, className, style }: TitledContentProps): JSX.Element => {
    return (
        <Col style={style} className={clsx(className, "title-content")}>
            {title && (
                <>
                    <TitledContentHeder className="title-content-header">
                        <Typography variant="body1Strong" textAlign="center" textTransform="uppercase">
                            {title}
                        </Typography>
                    </TitledContentHeder>
                    <Divider />
                </>
            )}
            <TitledContentBody flex={1} className="title-content-body">
                {body}
            </TitledContentBody>
        </Col>
    );
};

export default TitledContent;
